/**
 * FAIR Design System v2 — typed token names & Figma-aligned component props.
 * Used by primitives in src/ui/primitives/
 */

/** Figma Button: Style= (full set — includes not-yet-implemented) */
export const FAIR_BUTTON_STYLES = [
  'primary',
  'secondary',
  'gradient',
  'tonal',
  'tonal-action',
  'flat',
  'flat-action',
  'glass',
  'outlined',
  'outlined-action',
  'transparent',
] as const

export type FairButtonStyle = (typeof FAIR_BUTTON_STYLES)[number]

/** Implemented variants — import from button.data.ts */
export type {
  FairButtonPreviewState,
  FairButtonVariant,
  FairButtonV1Variant,
} from './button.data'

/** Figma Button: Size= */
/** `medium` / `small` / `mobile` = DS Button sizes (232:4189); `l` / `m` are the legacy v1 scale. */
export const FAIR_BUTTON_SIZES = ['medium', 'small', 'mobile', 'auto', 'l', 'm'] as const
/** `auto` — Medium from 1024, Mobile below (for places that do not know the breakpoint). */
export const FAIR_BUTTON_DS_SIZES = ['medium', 'small', 'mobile', 'auto'] as const
export type FairButtonSize = (typeof FAIR_BUTTON_SIZES)[number]

/** Figma Button: Theme= */
export const FAIR_THEMES = ['light', 'dark'] as const
export type FairTheme = (typeof FAIR_THEMES)[number]

/** Figma component states shared across inputs */
export const FAIR_INTERACTION_STATES = ['idle', 'hovered', 'pressed', 'disabled', 'focused'] as const
export type FairInteractionState = (typeof FAIR_INTERACTION_STATES)[number]

/** Planned primitives — track migration from Figma Inputs section */
export const FAIR_PRIMITIVE_COMPONENTS = [
  'FairIcon',
  'FairIconContainer',
  'FairLoginIcon',
  'FairInputText',
  'FairInputListItem',
  'FairAutocomplete',
  'FairButton',
  'FairAiButton',
  'FairIconButton',
  'FairTooltip',
  'FairLink',
  'FairPaginationBar',
  'FairInputText',
  'FairTextarea',
  'FairCheckbox',
  'FairRadioButton',
  'FairToggleSwitch',
  'FairSelect',
  'FairMultiSelect',
  'FairAutocomplete',
  'FairChip',
  'FairSlider',
  'FairBadge',
  'FairAvatar',
  'FairLabel',
] as const

export type FairPrimitiveComponent = (typeof FAIR_PRIMITIVE_COMPONENTS)[number]

/** Planned patterns — Figma Data display / Custom / Profile */
export const FAIR_PATTERN_COMPONENTS = [
  'FairProductCardV2',
  'FairCapsuleCardV2',
  'FairSelectionsCardV2',
  'FairShopCard',
  'FairCompareTable',
  'FairTableCell',
  'FairTableRow',
  'FairBlockHeading',
  'FairAiTip',
  'FairGallery',
  'FairSiteHeader',
  'FairAddPhotoCard',
  'FairActionModal',
  'FairDrawer',
] as const

export type FairPatternComponent = (typeof FAIR_PATTERN_COMPONENTS)[number]
